import { UpdateManyMap } from '@modules/shortlist/api/shortlist'
import { Shortlist } from '@modules/shortlist/types'

export const updateItemInTheMap = (
  map: UpdateManyMap,
  { name, status, rawShortlist }: { name?: string; status?: Shortlist['status']; rawShortlist: Shortlist },
) => {
  const existingMapItem = map[rawShortlist.id]

  if (!existingMapItem) {
    return {
      ...map,
      [rawShortlist.id]: {
        name,
        status,
        id: rawShortlist.id,
      },
    }
  }

  const hasNameChanged = name !== undefined && rawShortlist.name !== name
  const hasStatusChanged = status !== undefined && rawShortlist.status !== status

  if (hasNameChanged) {
    return {
      ...map,
      [rawShortlist.id]: { ...(existingMapItem || {}), name },
    }
  }

  if (hasStatusChanged) {
    return {
      ...map,
      [rawShortlist.id]: { ...(existingMapItem || {}), status },
    }
  }

  const { [rawShortlist.id]: _, ...newMap } = map

  return newMap
}
